import TextInput from "components/form/input/TextInput"
import {
    GenericParamFields,
    ParamFormRow
} from "entity/Indicador/components/ParamFields"
import Bio from ".."

export function BioParamFields({ tipoIndicadorField }) {
    return (
        <GenericParamFields
            name={Bio.field + tipoIndicadorField}
            tabFields={
                <>
                    <ParamFormRow label="Metro Linear">
                        <TextInput name="metroLinear" label="Valor (m)" type="number" />
                    </ParamFormRow>

                    <ParamFormRow label="Canas Avaliadas">
                        <TextInput name="canasAvaliadas" label="Valor (un.)" type="number" />
                    </ParamFormRow>

                    <ParamFormRow label="Metros Avaliados">
                        <TextInput name="metrosAvaliados" label="Valor (m)" type="number" />
                    </ParamFormRow> 
                </>
            }
        />
    );
}
